import React from "react";
import { GlCheckbox } from "@adl/component-checkbox";
import { useTranslations } from "@crystal/translator";
const SelectAllConsents = (props) => {
  const t = useTranslations();
  const { onChange } = props;
  return /* @__PURE__ */ React.createElement(GlCheckbox, { ...props, name: "selectAllConsents", label: t("permission.selectAllConsentLabel"), onChange });
};
export {
  SelectAllConsents
};
//# sourceMappingURL=select-all-consents.js.map
